import * as React from 'react';
export const IcDevotion = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 5a1.5 1.5 0 001.39-.93 1.49 1.49 0 00.08-.86A1.49 1.49 0 0012.29 2a1.49 1.49 0 00-.86.08 1.55 1.55 0 00-.68.56A1.5 1.5 0 0012 5zm7.71 14.29A1 1 0 0019 19h-8l5.6-4.2a1 1 0 00.37-.54 1 1 0 000-.65l-3-7a1.209 1.209 0 00-.24-.35 1 1 0 00-.37-.21 1 1 0 00-.42 0 .94.94 0 00-.4.13L8 8.82 5.55 7.17A1 1 0 005.18 7a1.12 1.12 0 00-.41 0 1 1 0 00-.68.44.84.84 0 00-.15.38.94.94 0 000 .41c.038.133.099.258.18.37.09.108.198.2.32.27l3 2a1 1 0 001.06 0l4-2.41 2.24 5.22L7.4 19.2a1 1 0 00-.35.5.94.94 0 000 .62A1 1 0 008 21h11a1 1 0 00.71-1.71z'
      fill='currentColor'
    />
  </svg>
);
